// F:\basick-ecommerce\frontend\src\data\products.js
import { CONFIG } from '../config/config';

const BASE_DESC =
  'Premium cotton tee with a clean, minimal silhouette. Pre-shrunk fabric and reinforced seams for everyday wear.';

export const PRODUCTS = [
  {
    id: 1,
    name: 'Classic Black Tee',
    price: CONFIG.PRICE.CURRENT,
    originalPrice: CONFIG.PRICE.ORIGINAL,
    category: 't-shirts',
    sizes: ['M', 'L', 'XL'],
    images: ['/images/tee-1.svg', '/images/tee-2.svg'],
    image: '/images/tee-1.svg',
    description: BASE_DESC,
    featured: true,
    brand: 'BASICK',
    isNew: true,
  },
  {
    id: 5,
    name: 'Oversized Tee',
    price: CONFIG.PRICE.CURRENT,
    originalPrice: CONFIG.PRICE.ORIGINAL,
    category: 't-shirts',
    sizes: ['M', 'L', 'XL'],
    images: ['/images/tee-2.svg', '/images/tee-3.svg'],
    image: '/images/tee-2.svg',
    description: BASE_DESC,
    featured: true,
    brand: 'BASICK',
  },
  {
    id: 9,
    name: 'Essential Tee - White',
    price: CONFIG.PRICE.CURRENT,
    originalPrice: CONFIG.PRICE.ORIGINAL,
    category: 't-shirts',
    sizes: ['M', 'L', 'XL'],
    images: ['/images/tee-4.svg', '/images/tee-1.svg'],
    image: '/images/tee-4.svg',
    description: BASE_DESC,
    brand: 'BASICK',
  },
  {
    id: 10,
    name: 'Relaxed Fit Tee',
    price: CONFIG.PRICE.CURRENT,
    originalPrice: CONFIG.PRICE.ORIGINAL,
    category: 't-shirts',
    sizes: ['M', 'L', 'XL'],
    images: ['/images/tee-3.svg', '/images/tee-4.svg'],
    image: '/images/tee-3.svg',
    description: BASE_DESC,
    brand: 'BASICK',
  },
];

export const FEATURED_PRODUCTS = PRODUCTS.filter((p) => p.featured);
